import { Injectable } from '@angular/core';
import { UserService } from '@app/services/user.service';

@Injectable({ providedIn: 'root' })
export class LoginSuccessService {
    private readonly defaultLoginPath = '/rewardpoints';
    private _successRedirectPath = '/rewardpoints';

    constructor(private userService: UserService) {}

    set loginSuccessRedirectPath(path: string) {
        this._successRedirectPath = !path ? this.defaultLoginPath : path;
    }

    get loginSuccessRedirectPath(): string {
        this.checkCartAndSetRedirectPath();
        return this._successRedirectPath || this.defaultLoginPath;
    }

    private checkCartAndSetRedirectPath(): void {
        const cartItemsCount = this.getCartItemsCount();
        if (cartItemsCount > 0) {
            this._successRedirectPath = '/checkout';
        } else if (this._successRedirectPath === '') {
            this._successRedirectPath = this.defaultLoginPath;
        }
    }

    private getCartItemsCount(): number {
        const localCart = this.userService.getLocalCart();
        return localCart?.itemCount || 0;
    }
}
